import React from 'react';
import styled from 'styled-components';
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';
import { NumColumns } from '../constants';
import { mapBreakpoints } from '../mixins/breakpoint';
import column, {
    columnEnd,
    columnInline,
    columnOffset,
    columnSize,
} from '../mixins/column';

const end = (colEnd) => {
    if (typeof colEnd === 'boolean') {
        return colEnd ? columnEnd : undefined;
    }

    if (typeof colEnd === 'object') {
        return mapBreakpoints(colEnd, (isEnd) => {
            return isEnd ? columnEnd : columnInline;
        });
    }
};

const size = (colSize) => {
    if (typeof colSize === 'number') {
        return columnSize(colSize);
    }

    if (typeof colSize === 'object') {
        return mapBreakpoints(colSize, columnSize);
    }
};

const offset = (colOffset) => {
    if (typeof colOffset === 'number') {
        return columnOffset(colOffset);
    }

    if (typeof colOffset === 'object') {
        return mapBreakpoints(colOffset, columnOffset);
    }
};

/**
 * @param {string} Component - An HTML element type name such as 'div'
 * @param {React.children} children
 * @param {number} numColumns
 * @param {Object} props
 * @return {JSX.Element}
 */
const BaseColumn = ({
    component: Component = 'div',
    children,
    size: numColumns = NumColumns,
    ...props
}) => {
    return (
        <Component {...filterToValidAttributes(props)}>{children}</Component>
    );
};

/**
 * @param {string} Component - An HTML element type name such as 'div'
 * @param {React.children} children
 * @param {bool|BreakpointsToBooleans} end
 * @param {number} numColumns
 * @param {number|BreakpointsToNumbers} offset
 * @param {Object} props
 * @param {number|BreakpointsToNumbers} size
 * @return {JSX.Element}
 */
const Column = styled(BaseColumn)`
    ${column}
    ${(props) => size(props.size)}
    ${(props) => offset(props.offset)}
    ${(props) => end(props.end)}
`;

export default Column;
